import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["circle"]

  submit() {
    this.circleTarget.classList.add("todo-check-loading")
  }
}
